module.exports = __webpack_public_path__ + "static/img/sx.a92b316.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sx.jpg
// module id = P8is
// module chunks = 1